export default __webpack_public_path__ + "book_details-publication_date.36db0059.png";